import FetchHelper from '../../helpers/fetchHelper';
import notification from '../../components/notification';

const actions = {
  CLEAR_ALL: 'CLEAR_ALL',
  clearAll: () => ({ type: actions.CLEAR_ALL }),

  SEARCH_USER: 'SEARCH_USER',
  searchUser: () => ({ type: actions.SEARCH_USER }),

  SAVE_USER: 'SAVE_USER',
  saveUser: (user) => ({ type: actions.SAVE_USER, payload:user }),

  SET_URL: 'SET_URL',
  setURL: (locationURL) => ({ type: actions.SET_URL, payload:locationURL }),

  SET_REPORT: 'SET_REPORT',
  setReport: (report) => ({ type: actions.SET_REPORT, payload:report }),

  SET_TAB: 'SET_TAB',
  setTab: (payload) => ({ type: actions.SET_TAB, payload:payload }),

  getTicket: id => {
    return (dispatch, getState) => new Promise((resolve, reject) => {
       FetchHelper.httpRequest('GET', 'ticket/'+id).then(result => {
        if (result.error) {
          notification('error', result.error_msg, 'No se pudo obtener la solicitud');
          resolve(result)
        } else {
          resolve(result.data)
        }

      });
    });
  },

  setStatusTicket: (id, status, body)=> {
    return(dispatch, getState) => new Promise ((resolve, reject)=>{
      FetchHelper.httpRequest('PUT', 'ticket/'+id+'?estado='+status, body).then(
        result =>{
          if (result.error) {
            notification('error', result.error_msg, 'No se pudo cambiar el estado de la solicitud a '+status);
          } else {
            switch (status) {
              case 'Nuevo':
                notification('success', 'Bien!', 'Solicitud Nº '+id+' marcado como no leido');
                break;
              case 'Procesando':
                //notification('success', 'Bien!', 'Solicitud Nº '+id+' procesando');
                break;
              case 'Espera':
                notification('success', 'Bien!', 'Solicitud Nº '+id+' puesto en espera');
                break;
              case 'Cerrado':
                notification('success', 'Bien!', 'Solicitud Nº '+id+' cerrado');
                break;
              default:
                break;
            }
          }
          resolve(result)
        }
      )
    })
  },



  saveDeriveTicket: (id, sector, body) => {
    return(dispatch) => new Promise ((resolve, reject)=>{
      FetchHelper.httpRequest('PUT', 'ticket/'+id+'/area/'+sector, body).then(
        result =>{
          if (result.error) {
            notification('error', result.error_msg, 'No se pudo derivar la solicitud');
          } else {
            notification('success', 'Bien!', 'Solicitud Nº '+id+' derivado');
          }
          resolve(result)
        }
      )
    })
  },

  saveRetakeTicket: (id) => {
    return(dispatch) => new Promise ((resolve, reject)=>{
      FetchHelper.httpRequest('PUT', 'ticket/'+id+'/retomar').then(
        result =>{
          if (result.error) {
            notification('error', result.error_msg, 'No se pudo retomar la solicitud');
          } else {
            notification('success', 'Bien!', 'Solicitud Nº '+id+' retomada');
          }
          resolve(result)
        }
      )
    })
  },

  saveTicket: (body, autoClose = false) => {
    return (dispatch, getState) => new Promise((resolve, reject) => {
      FetchHelper.httpRequest('POST', `ticket?autoClose=${autoClose}`, body).then(result => {
        if (result.error) {
          notification('error', result.error_msg, 'No se pudo guardar la solicitud');
        } else {
          notification('success', 'Bien!', 'Solicitud creado con exito');
        }
        resolve(result)
      });
    })
  },

  saveTitular: (body, sectorid) => {
    return(dispatch) => new Promise ((resolve, reject)=>{
      FetchHelper.httpRequest('POST', 'titular', body).then(result => {
        if (result.error) {
          notification('error', result.error_msg);
          resolve(result)
        } else {
          resolve(result)
        }
      });
    })
  },

  FETCH_NOTIFICATIONS: 'FETCH_NOTIFICATIONS',
  SET_NOTIFICATIONS: 'SET_NOTIFICATIONS',

  fetchNotifications: (codigoTitular) => {
    return (dispatch) => {
      FetchHelper.httpRequest('GET', `notificacion/titular/${codigoTitular}?vencidos=0&rowMax=20`).then(result => {
        if (!result.error) {
          dispatch({ type: actions.SET_NOTIFICATIONS, payload: result.data });
        }
      });
    };
  },

}
export default actions;
